<template>
  <div class="table-operate">
    <div
      class="btn"
      v-for="(item, index) in iconList"
      :key="index"
    >
      <el-tooltip
        v-if="item.icon"
        class="item"
        effect="dark"
        :content="item.name"
        placement="top"
      >
        <sino-button
          type="text"
          :icon="item.icon"
          @click="item.methods(scope)"
          v-if="item.showBtn && btnPermissions(item.permission)"
        ></sino-button>
      </el-tooltip>
      <sino-button
        type="text"
        :class="item.className?item.className:''"
        @click="btnClick(item,scope)"
        v-if="item.showBtn && btnPermissions(item.permission)&&!item.icon"
      >{{item.name}}</sino-button>
    </div>
    <!-- <el-popover
      placement="top"
      width="106"
      popper-class="btn-table-pop"
      trigger="hover"
      :close-delay="0"
      v-if="popBtnList.length > 0"
    >
      <i slot="reference" style="margin-left: 13px" class="el-icon-more"></i>
      <div>
        <div v-for="(item, index) in popBtnList" :key="index">
          <el-button type="text" v-if="item.showFlag" @click="item.methods(scope)">{{
            item.name
          }}</el-button>
        </div>
      </div>
    </el-popover> -->
    <el-dropdown v-if="popBtnList.length > 0">
      <el-button type="text">
        <i class="el-icon-more"></i>
      </el-button>
      <el-dropdown-menu
        slot="dropdown"
        class="btn-dropdown"
      >
        <el-dropdown-item
          v-for="(item, index) in popBtnList"
          :key="index"
          @click.native="item.methods(scope)"
        >{{ item.name }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import sinoButton from "../button/sinoButton.vue";
import utils from "../../scripts/utils.js";
export default {
  components: {
    sinoButton,
  },
  // props:['scope','btnList'],
  props: {
    scope: {
      type: Object,
      default() {
        return null;
      },
    },
    btnList: {
      //操作列按钮列表
      type: Array,
      default() {
        return [];
      },
    },
    num: {
      type: Number,
      default: () => {
        return 3;
      },
    },
  },
  watch: {
    btnList: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.iconList = [];
          this.popBtnList = [];
          //isShow 按钮显示隐藏判断逻辑的方法，不包括权限码
          //permission 权限码
          val.forEach((el) => {
            el.showBtn = true;
            el.permissionFlag =
              el.permission != undefined
                ? this.btnPermissions(el.permission)
                : true;
            el.showFlag = el.showFlag == undefined ? true : el.showFlag;
            if (el.isShow != undefined) {
              el.showBtn = el.isShow(this.scope) && el.showFlag;
            } else {
              el.showBtn = el.showFlag;
            }
            // if (el.showBtn && el.permissionFlag) {
            //   if (this.iconList.length < this.hiddenNum) {
            //     this.iconList.push(el);
            //   } else {
            //     this.popBtnList.push(el);
            //   }
            // }
          });
          this.allBtnList = val.filter((el) => {
            return el.showBtn && el.permissionFlag;
          });
          this.getBtnList();
        }
      },
    },
  },
  data() {
    return {
      hiddenNum: this.num,
      iconList: [], //未折叠按钮组
      popBtnList: [], //折叠按钮组
      allBtnList: [],
    };
  },
  methods: {
    btnPermissions(key) {
      return key ? utils.isAuth(key) : true;
    },
    getBtnList() {
      let len = this.allBtnList.length;
      if (len <= this.hiddenNum) {
        this.iconList = this.allBtnList;
      } else {
        this.iconList = this.allBtnList.slice(0, this.hiddenNum - 1);
        this.popBtnList = this.allBtnList.slice(this.hiddenNum - 1, len);
      }
    },
    btnClick(item, scope) {
      return item.methods(scope);
    },
  },
};
</script>
<style scoped>
.btn + .btn {
  margin-left: 8px;
}
/deep/.el-dropdown {
  margin-left: 13px;
}
/deep/.el-button [class*="el-icon-"] + span {
  margin-left: 0;
}
/deep/.svg-icon {
  margin-right: 0 !important;
}
</style>
